import { useContext, useEffect, useState } from "react";
import { DeductionDto } from "../../../../dtos/catalogs/deduction/DeductionDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import DeductionDetailSkeleton from "./DeductionDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import DeductionDetailMain from "./DeductionDetailMain";

interface IProps {
  model: DeductionDto | null;
  modelUpdatedEvent: (newModel: DeductionDto) => void;
}

interface DeductionModel {
  name: string;
  uniqueCode?: string;
  description: string;
  deductionType?: number;
  createdDate: Date;
  withholdingTaxRateId?: string;
  settlementsAccountId?: string;
  withholdingTaxId?: string;
  pensionContributionAccountId?: string;
  accountDeductionId?: string;
  referenceType?: number;
  createdUserId?: string;
  id: string;
}

export const DeductionDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<DeductionModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("uniqueCode", model.uniqueCode);
      setValue("description", model.description);
      setValue("deductionType", model.deductionType);
      setValue("createdDate", model.createdDate);
      setValue("withholdingTaxRateId", model.withholdingTaxRateId);
      setValue("settlementsAccountId", model.settlementsAccountId);
      setValue("withholdingTaxId", model.withholdingTaxId);
      setValue("pensionContributionAccountId", model.pensionContributionAccountId);
      setValue("accountDeductionId", model.accountDeductionId);
      setValue("referenceType", model.referenceType);
      setValue("createdUserId", model.createdUserId);
      setValue("referenceType", model.referenceType);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: DeductionModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: DeductionDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <DeductionDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <DeductionDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
